import { useTheme } from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { ROUTES, SUPER_APP_CONFIG, BUTTON_LABELS } from '../../utils/constants'
import {useResponsive} from 'shared-ui/hooks'
import { media } from '../../utils/media'
const GuestUserModal = ({
    title = `${SUPER_APP_CONFIG.GUEST_RESTRICTED_FEATURE}`,
    message = `${SUPER_APP_CONFIG.GUEST_FEATURE_REQUIREMENT}`,
    primaryLabel = `${BUTTON_LABELS.signIn}`,
    secondaryLabel = `${BUTTON_LABELS.createNewAccount}`,
    onClose
}) => {
    const theme = useTheme()
    const navigate = useNavigate()
    const isMobile = useResponsive(media.mobile)
    const signInBtnClick = () => {
        navigate(ROUTES.login)
    }

    const registerClick = () => {
        navigate(ROUTES.register)
    }
    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 text-left"
            onClick={onClose}
        >
            <div
                className="relative p-7 rounded-2xl shadow-xl w-80 "
                style={{
                    background: theme.app.background,
                    color: theme.app.iconlabel,
                    width: isMobile ? '' : '400px'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-2xl font-bold mb-3">{title}</h2>
                <p className="text-sm mb-5">{message}</p>

                <div
                    className={`flex ${isMobile ? `justify-center` : `justify-end`} gap-4`}
                >
                    <button
                        onClick={signInBtnClick}
                        className="text-sky-400 hover:underline"
                    >
                        {primaryLabel}
                    </button>
                    <button
                        onClick={registerClick}
                        className="text-sky-400 hover:underline"
                    >
                        {secondaryLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default GuestUserModal
